module.exports = __webpack_public_path__ + "img/NS-tab.4b047bbc.jpg";